import { WithClass } from '@decadia/shared/types/extend-default-props'
import clsx from 'clsx'
import { HTMLMotionProps, motion } from 'framer-motion'
import { t } from 'i18next'
import { FC } from 'react'
import { useShallow } from 'zustand/shallow'
import { useStore } from '../../hooks/use-store'
import styles from './meta-menu.module.css'

export const MetaMenu: FC<WithClass<HTMLMotionProps<'div'>>> = ({ className, ...rest }) => {
	const { links } = useStore(
		useShallow(({ links }) => ({
			links,
		}))
	)

	return (
		<motion.nav {...rest} className={clsx(className)}>
			<ul className={styles.list}>
				{links?.imprint && (
					<li>
						<a href={links?.imprint} target="_blank" rel="noreferrer">
							{t('metaMenu.imprint')}
						</a>
					</li>
				)}
				{links?.dataprotection && (
					<li>
						<a href={links?.dataprotection} target="_blank" rel="noreferrer">
							{t('metaMenu.dateProtection')}
						</a>
					</li>
				)}
				{links?.cookiesandservices && (
					<li>
						<a href={links?.cookiesandservices} target="_blank" rel="noreferrer">
							{t('metaMenu.cookiesAndServices')}
						</a>
					</li>
				)}
			</ul>
		</motion.nav>
	)
}
